import { ENDPOINTS } from 'config/endpoints';
import { useQuery } from '@tanstack/react-query';
import CronoError from 'crono-fe-common/types/error';
import client from 'utils/clients/client';
import { Request } from 'crono-fe-common/types/request';
import { Response } from 'crono-fe-common/types/response';
import { Opportunity } from 'crono-fe-common/types/DTO/opportunityViewResponseDTO';
import { OpportunitySearchAccount } from 'crono-fe-common/types/DTO/opportunitySearch';

type AccountOpportunityResponse = Response<Opportunity[]> & {
  data: {
    count: number;
  };
};

export default function useSearchAccountOpportunity<
  TData = AccountOpportunityResponse,
>(
  search: Omit<OpportunitySearchAccount, 'offset'>,
  select?: (response: AccountOpportunityResponse) => TData,
) {
  const requestBody = {
    data: { ...search, offset: 0 },
  };

  const request: Request = {
    url: ENDPOINTS.opportunity.search.account,
    config: {
      method: 'post',
      data: requestBody,
    },
  };

  return useQuery<AccountOpportunityResponse, CronoError, TData>({
    queryKey: [ENDPOINTS.opportunity.search.account, search],
    queryFn: () => client(request),
    enabled: !!search.accountId,
    keepPreviousData: true,
    select,
  });
}
